module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "qr-wechat.9b54fe52.jpg";